import { SampleActivityDto } from '@/api/ApiClient';
import { useTreeStore } from '@/stores/treeStore';

/**
 * Select a tree node and mark its data as modified so detail views open in edit mode.
 */
export function focusTreeNodeInEditMode(nodeId: string): void {
  const store = useTreeStore.getState();
  store.setSelectedNode(nodeId);
  const node = store.nodes.get(nodeId);
  if (node) {
    store.setDataModified(node.dataId, true);
  }
}

type SampleActivityTreeOps = {
  expandNode: (nodeId: string) => void;
  createNode: (type: 'sampleActivity', parentId: string, data: SampleActivityDto) => Promise<string | undefined>;
};

/**
 * Add a sample activity under a parent node, expand the parent, and focus the new node in edit mode.
 */
export async function attachSampleActivityInEditMode(
  parentNodeId: string,
  activity: SampleActivityDto,
  tree: SampleActivityTreeOps
): Promise<string | undefined> {
  tree.expandNode(parentNodeId);
  const newNodeId = await tree.createNode('sampleActivity', parentNodeId, activity);
  if (newNodeId) {
    focusTreeNodeInEditMode(newNodeId);
  }
  return newNodeId;
}
